import { FormControl, FormHelperText, Grid, InputLabel, OutlinedInput } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ExitStrategiesProps from './ExitStrategiesProps'

export default function IncrementalExitStrategyInput(props: ExitStrategiesProps) {
  const { backtestSettingInputData, handleInputChange, formErrors } = props

  const [localStart, setLocalStart] = useState<string | null>(null)
  const [localStop, setLocalStop] = useState<string | null>(null)
  const [localStep, setLocalStep] = useState<string | null>(null)

  useEffect(() => {
    setLocalStart(null)
  }, [backtestSettingInputData.generateTrades.incrementalStart])
  useEffect(() => {
    setLocalStop(null)
  }, [backtestSettingInputData.generateTrades.incrementalStop])
  useEffect(() => {
    setLocalStep(null)
  }, [backtestSettingInputData.generateTrades.incrementalStep])

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item lg={4} sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Incremental start</InputLabel>
            <OutlinedInput
              value={
                localStart !== null
                  ? localStart
                  : backtestSettingInputData.generateTrades.incrementalStart
              }
              name="generateTrades.incrementalStart"
              onChange={(e) => setLocalStart(e.target.value)}
              onBlur={() => {
                if (localStart !== null) {
                  const p = parseFloat(localStart)
                  if (!isNaN(p)) handleInputChange('generateTrades.incrementalStart', p)
                  setLocalStart(null)
                }
              }}
              type={'number'}
              inputProps={{ step: 0.00001, min: 0 }}
              label="Incremental start"
              error={!!formErrors.generateTrades?.incrementalStart}
            />
            <FormHelperText error={!!formErrors.generateTrades?.incrementalStart}>
              {formErrors.generateTrades?.incrementalStart}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item lg={4} sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Incremental stop</InputLabel>
            <OutlinedInput
              value={
                localStop !== null
                  ? localStop
                  : backtestSettingInputData.generateTrades.incrementalStop
              }
              name="generateTrades.incrementalStop"
              onChange={(e) => setLocalStop(e.target.value)}
              onBlur={() => {
                if (localStop !== null) {
                  const p = parseFloat(localStop)
                  if (!isNaN(p)) handleInputChange('generateTrades.incrementalStop', p)
                  setLocalStop(null)
                }
              }}
              type={'number'}
              inputProps={{ step: 0.00001, min: 0 }}
              label="Incremental stop"
              error={!!formErrors.generateTrades?.incrementalStop}
            />
            <FormHelperText error={!!formErrors.generateTrades?.incrementalStop}>
              {formErrors.generateTrades?.incrementalStop}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item lg={4} sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Incremental step</InputLabel>
            <OutlinedInput
              value={
                localStep !== null
                  ? localStep
                  : backtestSettingInputData.generateTrades.incrementalStep
              }
              name="generateTrades.incrementalStep"
              onChange={(e) => setLocalStep(e.target.value)}
              onBlur={() => {
                if (localStep !== null) {
                  const p = parseFloat(localStep)
                  if (!isNaN(p)) handleInputChange('generateTrades.incrementalStep', p)
                  setLocalStep(null)
                }
              }}
              type={'number'}
              inputProps={{ step: 0.00001, min: 0.00001 }}
              label="Incremental step"
              error={!!formErrors.generateTrades?.incrementalStep}
            />
            <FormHelperText error={!!formErrors.generateTrades?.incrementalStep}>
              {formErrors.generateTrades?.incrementalStep}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
